import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { CONTACT, waHref } from "@/lib/contact";

export default function FinalCTA() {
  return (
    <section
      id="contato"
      data-testid="final-cta-section"
      className="relative overflow-hidden bg-brand-yellow text-black"
    >
      {/* hazard tape top */}
      <div
        aria-hidden="true"
        className="h-3 w-full"
        style={{
          backgroundImage:
            "repeating-linear-gradient(135deg, #050505 0 22px, #fdb704 22px 44px)",
        }}
      />

      <div className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-mono text-xs tracking-[0.4em]"
        >
          [ CHAMADA FINAL ]
        </motion.p>

        <motion.h2
          data-testid="final-cta-h2"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="mt-4 font-display text-[13vw] leading-[0.85] tracking-[-0.02em] sm:text-[9vw] lg:text-[7.5vw]"
        >
          NÃO FIQUE <br />
          <span className="italic">parado.</span> <br />
          FALE AGORA.
        </motion.h2>

        <div className="mt-12 grid grid-cols-12 gap-6 border-t border-black/25 pt-10 sm:mt-16">
          <div className="col-span-12 sm:col-span-6">
            <p className="max-w-md font-body text-lg leading-relaxed sm:text-xl">
              Estamos com plantão ativo agora mesmo em Belém, Ananindeua,
              Marituba e Região Metropolitana. Um clique resolve.
            </p>
          </div>

          <div className="col-span-12 flex flex-col gap-4 sm:col-span-6 sm:items-end">
            <a
              data-testid="cta-whatsapp-btn"
              href={waHref}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex w-full items-center justify-between gap-4 bg-brand-green px-6 py-5 font-display text-xl uppercase tracking-widest text-white transition-all hover:bg-brand-green-dark active:scale-[0.98] sm:w-auto sm:text-2xl"
            >
              <span className="flex items-center gap-3">
                <MessageCircle className="h-6 w-6" strokeWidth={2.5} />
                CHAMAR NO WHATSAPP
              </span>
              <span className="font-mono text-xs tracking-[0.3em] text-white/70 transition-colors">
                {CONTACT.phoneDisplay}
              </span>
            </a>
            <a
              data-testid="cta-call-btn"
              href={CONTACT.telHref}
              className="group inline-flex w-full items-center justify-between gap-4 bg-black px-6 py-5 font-display text-xl uppercase tracking-widest text-brand-yellow transition-all hover:bg-neutral-900 active:scale-[0.98] sm:w-auto sm:text-2xl"
            >
              <span className="flex items-center gap-3">
                <Phone className="h-6 w-6" strokeWidth={2.5} />
                LIGAR AGORA
              </span>
              <span className="font-mono text-xs tracking-[0.3em] text-white/60">
                {CONTACT.phoneDisplay}
              </span>
            </a>
            <a
              data-testid="cta-email-link"
              href={`mailto:${CONTACT.email}`}
              className="mt-2 text-sm underline decoration-black/40 underline-offset-4 hover:decoration-black"
            >
              {CONTACT.email}
            </a>
          </div>
        </div>
      </div>

      {/* hazard tape bottom */}
      <div
        aria-hidden="true"
        className="h-3 w-full"
        style={{
          backgroundImage:
            "repeating-linear-gradient(135deg, #050505 0 22px, #fdb704 22px 44px)",
        }}
      />
    </section>
  );
}
